import React from "react";
import {
    Autocomplete,
    FilterRemoveIcon,
    Heading,
    IconButton,
    Label,
    Pane,
    Paragraph,
    TextInputField,
    toaster,
    Tooltip
} from "evergreen-ui";
import FiltersPanel from "../common/FiltersPanel";
import {useDispatch, useSelector} from "react-redux";
import {operationsSelector, selectorStationsForFilters, temporaryTurnSelector} from "../periodValuesFilterApi";
import {
    addTTFilterRow,
    deleteTTRowAction,
    deselectTTResultOperationAction,
    selectTTCodeAction,
    selectTTDatasourceAction,
    selectTTDatasourceTypeAction, selectTTEntityAction,
    selectTTResultOperationAction,
    selectTTStationAction,
    setNewTTConstructor
} from "../constructorSlice";
import {findFirstByName} from "../common/matchMethods";
import TemporaryTurnTable from "./TemporaryTurnTable";
import {getDatasourceTypesByStation} from "../decadeConstructor/ApiCalls";
import {createTemplate} from "./ApiCalls";
import {getTTConstructorRights} from "../../Privileges/PrivilegesSelectors";
import CreateOutputFormTTDialog from "./CreateOutputFormTTDialog";
import {defaultConstructor} from "../common/constructorObject";
import OperationsComponent from "../common/OperationsComponent";
import SmartButton from "../common/SmartButton";
import CreateTemplateDialog from "../common/CreateTemplateDialog";
import {createFullStationName, createFullStationNameWithOuterIdx} from "../Constructor.DefaultPage";
import {AutoCompleteConstructor} from "../../BaseConstructor/BaseConstructor";


export default function TemporaryTurnPage({isFullInfo, isEdit}) {
    const dispatch = useDispatch()

    const privileges = useSelector(state => state.login.privileges)
    const rights = getTTConstructorRights(privileges)

    const stations = useSelector(selectorStationsForFilters);

    const constructor = useSelector(temporaryTurnSelector)
    const operations   = useSelector(operationsSelector);

    const tableOperations = constructor.tableOperations;
    const filters = constructor.filtersRows;

    const setShownCallback = (shown) => setIsShown(shown)

    const [idx, setIdx] = React.useState(chooseIdx())

    const [dsourceTypes, setDsourceTypes] = React.useState([])


    function chooseIdx() {
        for (let i = 0; i < stations.length; i++) {
            if (stations[i].name === constructor.station.name)
                return stations[i].idx
        }
        return undefined
    }
    React.useEffect(() => {
        if (isFullInfo || isEdit) {
            setDsourceTypes(constructor.station.sourcesTypes)
        }
    })

    function clearFilter() {
        dispatch(setNewTTConstructor({...defaultConstructor}))
    }

    function onSelectStation(selectedItem) {
        clearFilter()
        setIdx(
            selectedItem.split("] ")[0]
                .replace("[", "")
        )
        selectedItem = selectedItem.split("] ")[1]
        let res = findFirstByName(stations, selectedItem)

        getDatasourceTypesByStation(res.id).then((result) => {
            setDsourceTypes(result.data)
            res = {id: res.id, name: res.name, sourcesTypes: result.data}
            dispatch(selectTTStationAction(res));
        })
    }

    const [isShown, setIsShown] = React.useState(false)

    const [createTemplateShown, setCreateTemplateShown] = React.useState(false)
    const setCreateTemplateShownCallback = (shown) => setCreateTemplateShown(shown)

    function checkAllFieldSet() {
        if (constructor.tableOperations.length === 0) {
            toaster.danger("Операции для таблицы не установлены")
            return false;
        }


        for (let i = 0; i < constructor.filtersRows.length; i++) {
            if (constructor.filtersRows[i].code.id === -1) {
                toaster.danger("Код для фильтра №" + (i+1) + " не установлен")
                return false
            }
        }

        return true
    }

    function isCreateTemplateDisabled() {
        return constructor.filtersRows[constructor.filtersRows.length-1].code.id === -1
    }

    function isOutputFormDisabled() {
        return constructor.filtersRows[constructor.filtersRows.length-1].code.id == -1
    }


    return (
        <Pane display="block" marginBottom={ isFullInfo || isEdit ? 50 : 150}>
            {
                !isFullInfo ?
                    isEdit? <></> : <Heading size={600}>Конструктор "Временного хода"</Heading> :
                    <>
                        <Pane display={"flex"} columnGap={20} marginBottom={5}>
                            <Pane marginTop={3}><Label>Тип шаблона: </Label></Pane>
                            <Pane><Paragraph>"Временной ход"</Paragraph></Pane>
                        </Pane>
                        <Pane display={"flex"} columnGap={20} marginBottom={15}>
                            <Pane marginTop={3}><Label>Название шаблона: </Label></Pane>
                            <Pane><Paragraph>"{constructor.name}"</Paragraph></Pane>
                        </Pane>
                    </>

            }

            <Pane
                display="block"
                marginTop={5}
                marginBottom={15}
            >

                <Pane display="flex" columnGap={10}>
                    <Pane columnGap={10}>
                        <Pane marginBottom={15} width={220}>
                            <Pane marginBottom={5}>
                                Станция
                            </Pane>
                            {AutoCompleteConstructor(
                                onSelectStation,
                                constructor,
                                idx,
                                stations,
                                isFullInfo,
                                createFullStationNameWithOuterIdx,
                                createFullStationName
                            )}
                        </Pane>
                        <Pane marginBottom={-15}>
                            <FiltersPanel
                                constructor={constructor}
                                filters={filters}
                                isFullInfo={isFullInfo}
                                onAddFilterButton={() => dispatch(addTTFilterRow())}
                                datasourceTypes={dsourceTypes}
                                deleteRowAction={deleteTTRowAction}
                                selectDatasourceTypeAction={selectTTDatasourceTypeAction}
                                selectDatasourceAction={selectTTDatasourceAction}
                                selectCodeAction={selectTTCodeAction}
                                selectEntityAction={selectTTEntityAction}
                            />
                        </Pane>
                    </Pane>
                </Pane>
            </Pane>

            <Pane display="flex" marginTop={-20} marginBottom={10}>
                <OperationsComponent operations={operations}
                                     disabled={isFullInfo}
                                     columns={['для таблицы']}
                                     columnsOnSelectActions={[selectTTResultOperationAction]}
                                     columnsOnDeselectActions={[deselectTTResultOperationAction]}
                                     selectedOperationsForColumns={[tableOperations]}
                />
            </Pane>


            {
                isFullInfo || isEdit ? <></> :
                    <Pane marginTop={-10} marginBottom={15} display={"flex"} columnGap={10}>
                        {
                            rights.canSaveTemplate ?
                                <SmartButton
                                    disabledTooltip={"Выберите фильтры"}
                                    buttonText={"Сохранить шаблон"}
                                    isPrimary={false}
                                    isDisabled={isCreateTemplateDisabled()}
                                    onClickAction={() => {
                                        if (checkAllFieldSet())
                                            setCreateTemplateShown(true)
                                    }}
                                /> : <></>
                        }
                        {
                            rights.canCreateOutputForm ?
                                <SmartButton
                                    disabledTooltip={"Выберите фильтры"}
                                    buttonText={"Выгрузить выходную форму"}
                                    isPrimary={false}
                                    isDisabled={isOutputFormDisabled()}
                                    onClickAction={() => {
                                        if (checkAllFieldSet())
                                            setIsShown(true);
                                    }}
                                /> : <></>
                        }

                        <Tooltip content="Сбросить">
                            <IconButton icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                        </Tooltip>
                    </Pane>

            }

            {
                isFullInfo || isEdit ? <></> :
                    <Pane height={360 + tableOperations.length * 40} >
                        <TemporaryTurnTable/>
                    </Pane>
            }

            <CreateTemplateDialog createTemplate={(templateName) => createTemplate(constructor, templateName)}
                                  setIsShown={setCreateTemplateShownCallback}
                                  isShown={createTemplateShown}
            />
            <CreateOutputFormTTDialog isShown={isShown} constructor={constructor} setIsShown={setShownCallback} name={""}/>
        </Pane>
    )

}